import Footer from './Footer';

Footer.install = function(Vue) {
  Vue.component(Footer.name, Footer);
};

export default Footer;
